import request from '../../utils/request';

export default fileId => request(`/master-data/${fileId}/receptacles`);
